import React, { useContext } from "react";
import { Grid, Button } from "@material-ui/core";
import CAShield from "../Assets/CAShield.png";
import Ironman from "../Assets/Ironman.png";
import Wanda from "../Assets/Wanda.png";
//import ThanosG from "../Assets/ThanosG.png";
import Mjolnir from "../Assets/Mjolnir.png";
import Spiderman from "../Assets/Spiderman.png";
import { AppContext } from "./Context.js";

import "../CSS/AboutMe.css";

export default function AboutMe({ id }) {
  const [itemSnapped] = useContext(AppContext);

  return (
    <React.Fragment>
      <div id={id} className={itemSnapped === "AboutMe" ? "vanish" : "aboutMe"}>
        <Grid container spacing={0} className="bgam">
          <Grid item md={12} sm={12} xs={12}>
            <div className="titleDiv">
              <h1 className="sectionsTitle">About me</h1>
            </div>
          </Grid>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            style={{ paddingLeft: "10vw", paddingRight: "10vw" }}
          >
            <span className="descr">Hi, It's me again</span>
            <span>😁</span>
            <span className="descr">
              Beside being interested in software development , I'm also a gamer
            </span>
            <span>🤫</span>
            <span className="descr">
              I spend most (if not all) my free time in playing online games
              like WorldOfWarcraft, Overwatch, RainbowSixSiege, Valorant, COD,
              and much more
            </span>
            <span>😎</span>
            <span className="descr">
              I guess it's obvious that Im a Marvel fan , right ?
            </span>
          </Grid>
          {/* <Grid item md={12} sm={12} xs={12} style={{ paddingTop: "20px" }}>
            <img
              src={Spiderman}
              alt=""
              style={{ width: 50, height: 50, padding: "20px" }}
            />
            <img
              src={Ironman}
              alt=""
              style={{ width: 50, height: 50, padding: "20px" }}
            />
            <img
              src={Wanda}
              alt=""
              style={{ width: 50, height: 50, padding: "20px" }}
            />
            <img
              src={Mjolnir}
              alt=""
              style={{ width: 50, height: 50, padding: "20px" }}
            />
            <img
              src={CAShield}
              alt=""
              style={{ width: 50, height: 50, padding: "20px" }}
            />
          </Grid> */}

          <Grid item md={12} sm={12} xs={12}>
            <Button
              target="_blank"
              href="https://1drv.ms/b/c/3f05f031a140028f/ER7LEoFcr2ZDqjmJgh3WjUUBpKcDv-xOhD5isOjul_9xGw?e=pHVtl9"
              className="sendMsgBtn"
              style={{ margin: "30px 0px 15px 0px" }}
            >
              Download CV
            </Button>
          </Grid>
        </Grid>
      </div>
    </React.Fragment>
  );
}
